"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("@mapbox/mr-ui/icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Browser = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Browser, _React$PureComponent);

  var _super = _createSuper(Browser);

  function Browser() {
    _classCallCheck(this, Browser);

    return _super.apply(this, arguments);
  }

  _createClass(Browser, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "shadow-darken25 round bg-white"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "bg-gray h30-mm h18 round-t"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "color-white flex-parent flex-parent--center-cross h30-mm h18 px6"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "color-red-light"
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: "circle"
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "color-yellow-light"
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: "circle"
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "color-green-light"
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: "circle"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "block-mm none"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "h30 bg-gray-faint color-gray flex-parent flex-parent--space-between-main px6 flex-parent--center-cross"
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '70px'
        },
        className: "flex-parent-inline flex-parent--space-between-main flex-parent--center-cross mr18"
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: "arrow-left"
      }), /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: "arrow-right"
      }), /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: "rotate"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "w120 h18 bg-white round-full flex-child--grow px12"
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '70px'
        },
        className: "flex-parent-inline flex-parent--space-between-main align-r flex-parent--center-cross ml18"
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: "heart"
      }), /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: "mapbox"
      }), /*#__PURE__*/_react.default.createElement(_icon.default, {
        name: "menu"
      })))), props.children);
    }
  }]);

  return Browser;
}(_react.default.PureComponent);

Browser.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = Browser;
exports.default = _default;